
// import React, { useState, useEffect, useRef } from 'react';
// import { Box, Typography, InputBase, IconButton, CircularProgress, Avatar } from '@mui/material';
// import { useSelector, useDispatch } from 'react-redux';
// import { AccountCircle } from '@mui/icons-material';
// import propertyImage from '../assets/inmenu.png';
// import userAvatar from '../assets/inboxuser.png';
// import agentAvatar from '../assets/inboxavatar.png';
// import attachIcon from '../assets/clipprof.png';
// import photoIcon from '../assets/clippho.png';
// import locationIcon from '../assets/cliploc.png';
// import sendIcon from '../assets/rocket.png';
// import tickIcon from '../assets/doubletick.png';
// import inboxheader from '../assets/inhead.png';
// import { setCurrentConversationId, setSenderId, setReceiverId, setConversations } from '../Commonlibs/userSlice';
// import Loader from '../Loader/Loader';

// // SVG icons for different message statuses
// const singleTickSvg = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
// <path d="M2.5 8L6.5 12L13.5 5" stroke="#888888" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
// </svg>`;

// const doubleTickSvg = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
// <path d="M2.5 8L6.5 12L13.5 5" stroke="#888888" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
// <path d="M0.5 8L4.5 12L11.5 5" stroke="#888888" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
// </svg>`;

// const doubleTickBlueSvg = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
// <path d="M2.5 8L6.5 12L13.5 5" stroke="#2563eb" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
// <path d="M0.5 8L4.5 12L11.5 5" stroke="#2563eb" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
// </svg>`;

// const ProfileInbox = () => {
//   const [conversations, setLocalConversations] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);
//   const [selectedConversation, setSelectedConversation] = useState(null);
//   const [messages, setMessages] = useState([]);
//   const [loadingMessages, setLoadingMessages] = useState(false);
//   const [messageError, setMessageError] = useState(null);
//   const [inputMessage, setInputMessage] = useState('');
//   const [currentConversationId, setLocalCurrentConversationId] = useState(null);
//   const [receiverId, setLocalReceiverId] = useState(null);
//   const [sendingMessage, setSendingMessage] = useState(false);
//   const [otherUserOnlineStatus, setOtherUserOnlineStatus] = useState(false);
//   const [otherUserLoggedInStatus, setOtherUserLoggedInStatus] = useState(false);

//   const onlineStatusIntervalRef = useRef(null);

//   const user = useSelector((state) => state.user.user);
//   const dispatch = useDispatch();

//   const userId = user?.id;

//   // Function to convert base64 to image URL
//   const convertBase64ToImageUrl = (base64String) => {
//     if (!base64String) return null;
    
//     if (base64String.startsWith('data:image')) {
//       return base64String;
//     }
    
//     if (base64String.startsWith('/9j/') || base64String.startsWith('iVBOR')) {
//       return `data:image/jpeg;base64,${base64String}`;
//     }
    
//     return null;
//   };

//   const checkOtherUserOnlineStatus = async (otherUserId) => {
//     if (!otherUserId) {
//       console.log('No other user ID available, skipping online status check');
//       return;
//     }

//     try {
//       console.log(`Checking online status for other user ID: ${otherUserId}`);
//       const apiUrl = `https://propertydealstalk.com/api/messaging/updateOnlineStatus`;
//       console.log('Other User Online Status API URL:', apiUrl);

//       const response = await fetch(apiUrl, {
//         method: 'POST',
//         headers: {
//           'Accept': 'application/json',
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify({
//           user_id: otherUserId,
//           is_online: true
//         })
//       });

//       if (!response.ok) {
//         console.error('Other user online status API response not OK:', response.status, response.statusText);
//         throw new Error(`Other user online status API request failed with status ${response.status}`);
//       }

//       const data = await response.json();
//       console.log('Other user online status API response:', data);

//       if (data.statusCode === 200) {
//         const isOnline = data.result?.is_online || false;
//         const isLoggedIn = data.result?.is_logged_in || false;
//         console.log(`Other user (${otherUserId}) online status:`, isOnline);
//         console.log(`Other user (${otherUserId}) logged in status:`, isLoggedIn);

//         const prevOnlineStatus = otherUserOnlineStatus;
//         const prevLoggedInStatus = otherUserLoggedInStatus;
//         setOtherUserOnlineStatus(isOnline);
//         setOtherUserLoggedInStatus(isLoggedIn);

//         setSelectedConversation(prevConversation => {
//           if (!prevConversation) return prevConversation;
//           return {
//             ...prevConversation,
//             is_other_user_online: isOnline,
//             is_other_user_logged_in: isLoggedIn
//           };
//         });

//         setMessages(prevMessages =>
//           prevMessages.map(msg => {
//             if (msg.sender_id === userId) {
//               if (!prevLoggedInStatus && isLoggedIn && msg.status === 'sent') {
//                 return { ...msg, status: 'delivered' };
//               }
//               else if (msg.status === 'read') {
//                 return msg;
//               }
//               else if (isOnline && msg.status === 'delivered') {
//                 return { ...msg, status: 'read' };
//               }
//               else if (prevLoggedInStatus && !isLoggedIn) {
//                 return { ...msg, status: 'sent' };
//               }
//             }
//             return msg;
//           })
//         );
//       } else {
//         console.error('Other user online status API returned non-200 status code:', data.statusCode);
//       }
//     } catch (err) {
//       console.error('Error checking other user online status:', err);
//     }
//   };

//   useEffect(() => {
//     if (!userId) {
//       console.log('No user ID available, skipping online status update');
//       return;
//     }

//     const updateOnlineStatus = async () => {
//       try {
//         console.log(`Updating online status for user ID: ${userId}`);
//         const apiUrl = `https://propertydealstalk.com/api/messaging/updateOnlineStatus`;
//         console.log('Online Status API URL:', apiUrl);

//         const response = await fetch(apiUrl, {
//           method: 'POST',
//           headers: {
//             'Accept': 'application/json',
//             'Content-Type': 'application/json',
//           },
//           body: JSON.stringify({
//             user_id: userId,
//             is_online: true
//           })
//         });

//         if (!response.ok) {
//           console.error('Online status update API response not OK:', response.status, response.statusText);
//           throw new Error(`Online status update API request failed with status ${response.status}`);
//         }

//         const data = await response.json();
//         console.log('Online status update API response:', data);

//         if (data.statusCode !== 200) {
//           console.error('Online status update API returned non-200 status code:', data.statusCode);
//           throw new Error(data.message || 'Failed to update online status');
//         }
//       } catch (err) {
//         console.error('Error updating online status:', err);
//       }
//     };

//     updateOnlineStatus();
//     const intervalId = setInterval(updateOnlineStatus, 1 * 60 * 1000);

//     const handleBeforeUnload = () => {
//       fetch(`https://propertydealstalk.com/api/messaging/updateOnlineStatus`, {
//         method: 'POST',
//         headers: {
//           'Accept': 'application/json',
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify({
//           user_id: userId,
//           is_online: false
//         }),
//         keepalive: true
//       }).catch(err => console.error('Error updating offline status:', err));
//     };

//     window.addEventListener('beforeunload', handleBeforeUnload);

//     return () => {
//       clearInterval(intervalId);
//       window.removeEventListener('beforeunload', handleBeforeUnload);
//       fetch(`https://propertydealstalk.com/api/messaging/updateOnlineStatus`, {
//         method: 'POST',
//         headers: {
//           'Accept': 'application/json',
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify({
//           user_id: userId,
//           is_online: false
//         }),
//         keepalive: true
//       }).catch(err => console.error('Error updating offline status on unmount:', err));
//     };
//   }, [userId]);

//   useEffect(() => {
//     if (onlineStatusIntervalRef.current) {
//       clearInterval(onlineStatusIntervalRef.current);
//       onlineStatusIntervalRef.current = null;
//     }

//     if (!receiverId) {
//       return;
//     }

//     checkOtherUserOnlineStatus(receiverId);

//     onlineStatusIntervalRef.current = setInterval(() => {
//       checkOtherUserOnlineStatus(receiverId);
//     }, 5 * 1000);

//     return () => {
//       if (onlineStatusIntervalRef.current) {
//         clearInterval(onlineStatusIntervalRef.current);
//         onlineStatusIntervalRef.current = null;
//       }
//     };
//   }, [receiverId]);

//   const markMessagesAsRead = async (conversationId) => {
//     if (!userId || !conversationId) {
//       console.log('Missing user ID or conversation ID, skipping mark as read');
//       return;
//     }

//     try {
//       console.log(`Marking messages as read for conversation ID: ${conversationId}, user ID: ${userId}`);
//       const apiUrl = `https://propertydealstalk.com/api/messaging/markMessagesAsRead`;
//       console.log('Mark as Read API URL:', apiUrl);

//       const response = await fetch(apiUrl, {
//         method: 'POST',
//         headers: {
//           'Accept': 'application/json',
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify({
//           conversation_id: conversationId,
//           user_id: userId
//         })
//       });

//       if (!response.ok) {
//         console.error('Mark as read API response not OK:', response.status, response.statusText);
//         throw new Error(`Mark as read API request failed with status ${response.status}`);
//       }

//       const data = await response.json();
//       console.log('Mark as read API response:', data);

//       if (data.statusCode !== 200) {
//         console.error('Mark as read API returned non-200 status code:', data.statusCode);
//         throw new Error(data.message || 'Failed to mark messages as read');
//       }

//       console.log(`Successfully marked ${data.result.messages_updated} messages as read`);

//       setLocalConversations(prevConversations =>
//         prevConversations.map(conv =>
//           conv.conversation_id === conversationId
//             ? {
//                 ...conv,
//                 last_message: {
//                   ...conv.last_message,
//                   status: 'read'
//                 }
//               }
//             : conv
//         )
//       );

//       setMessages(prevMessages =>
//         prevMessages.map(msg =>
//           msg.sender_id !== userId && msg.status !== 'read'
//             ? { ...msg, status: 'read' }
//             : msg
//         )
//       );
//     } catch (err) {
//       console.error('Error marking messages as read:', err);
//     }
//   };

//   useEffect(() => {
//     if (!userId) {
//       console.log('No user ID available, skipping API call');
//       return;
//     }

//     const fetchConversations = async () => {
//       setLoading(true);
//       try {
//         console.log(`Fetching conversations for user ID: ${userId}`);
//         const apiUrl = `https://propertydealstalk.com/api/messaging/conversations?user_id=${userId}`;
//         console.log('API URL:', apiUrl);

//         const response = await fetch(apiUrl, {
//           method: 'GET',
//           headers: {
//             'Accept': 'application/json',
//             'Content-Type': 'application/json',
//             'Cache-Control': 'no-cache, no-store'
//           }
//         });

//         if (!response.ok) {
//           console.error('API response not OK:', response.status, response.statusText);
//           throw new Error(`API request failed with status ${response.status}`);
//         }

//         const data = await response.json();
//         console.log('API response:', data);

//         if (data.statusCode === 200) {
//           console.log('Conversations data:', data.result);

//           const processedConversations = data.result.map(conversation => {
//             const imageUrl = convertBase64ToImageUrl(conversation.property?.image);
            
//             return {
//               ...conversation,
//               property: {
//                 ...conversation.property,
//                 image: imageUrl || propertyImage
//               }
//             };
//           });

//           setLocalConversations(processedConversations);

//           if (processedConversations && processedConversations.length > 0) {
//             try {
//               dispatch(setConversations(processedConversations));
//             } catch (err) {
//               console.error('Error updating Redux state:', err);
//             }
//           }

//           if (processedConversations.length > 0 && !currentConversationId) {
//             const firstConversation = processedConversations[0];
//             setSelectedConversation(firstConversation);
//             setLocalCurrentConversationId(firstConversation.conversation_id);

//             if (firstConversation.other_user && firstConversation.other_user.id) {
//               const otherUserId = firstConversation.other_user.id;
//               setLocalReceiverId(otherUserId);
//               checkOtherUserOnlineStatus(otherUserId);
//               try {
//                 dispatch(setReceiverId(otherUserId));
//               } catch (err) {
//                 console.error('Error updating Redux receiver ID:', err);
//               }
//             }

//             try {
//               dispatch(setCurrentConversationId(firstConversation.conversation_id));
//               if (firstConversation.other_user && firstConversation.other_user.id) {
//                 dispatch(setSenderId(firstConversation.other_user.id));
//               }
//             } catch (err) {
//               console.error('Error updating Redux state:', err);
//             }

//             fetchMessages(firstConversation.conversation_id);
//             markMessagesAsRead(firstConversation.conversation_id);
//           } else if (currentConversationId) {
//             const existingConversation = processedConversations.find(
//               conv => conv.conversation_id === currentConversationId
//             );
//             if (existingConversation) {
//               setSelectedConversation(existingConversation);
//               if (existingConversation.other_user && existingConversation.other_user.id) {
//                 const otherUserId = existingConversation.other_user.id;
//                 setLocalReceiverId(otherUserId);
//                 checkOtherUserOnlineStatus(otherUserId);
//                 try {
//                   dispatch(setReceiverId(otherUserId));
//                 } catch (err) {
//                   console.error('Error updating Redux receiver ID:', err);
//                 }
//               }
//               fetchMessages(currentConversationId);
//               markMessagesAsRead(currentConversationId);
//             }
//           }
//         } else {
//           console.error('API returned non-200 status code:', data.statusCode);
//           throw new Error(data.message || 'Failed to fetch conversations');
//         }
//       } catch (err) {
//         console.error('Error fetching conversations:', err);
//         console.error('Error details:', err.message);
//         console.error('Error stack:', err.stack);
//         setError(`Error: Failed to fetch. Please try again later.`);
//         setLocalConversations([]);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchConversations();
//   }, [userId, dispatch]);

//   const fetchMessages = async (conversationId) => {
//     if (!userId || !conversationId) {
//       console.log('Missing user ID or conversation ID, skipping message fetch');
//       return;
//     }

//     setLoadingMessages(true);
//     setMessageError(null);

//     try {
//       console.log(`Fetching messages for conversation ID: ${conversationId}, user ID: ${userId}`);
//       const apiUrl = `https://propertydealstalk.com/api/messaging/getMessages?conversation_id=${conversationId}&user_id=${userId}`;
//       console.log('Messages API URL:', apiUrl);

//       const response = await fetch(apiUrl, {
//         method: 'GET',
//         headers: {
//           'Accept': 'application/json',
//           'Content-Type': 'application/json',
//           'Cache-Control': 'no-cache, no-store'
//         }
//       });

//       if (!response.ok) {
//         console.error('Messages API response not OK:', response.status, response.statusText);
//         throw new Error(`Messages API request failed with status ${response.status}`);
//       }

//       const data = await response.json();
//       console.log('Messages API response:', data);

//       if (data.statusCode === 200) {
//         console.log('Messages data:', data.result.messages);
//         const messagesArray = Array.isArray(data.result.messages) ? data.result.messages : [];

//         const processedMessages = messagesArray.map(msg => {
//           if (msg.sender_id === userId) {
//             if (!msg.status) {
//               if (otherUserOnlineStatus) {
//                 return { ...msg, status: 'read' };
//               } else if (otherUserLoggedInStatus) {
//                 return { ...msg, status: 'delivered' };
//               } else {
//                 return { ...msg, status: 'sent' };
//               }
//             }
//           } else {
//             return { ...msg, status: 'read' };
//           }
//           return msg;
//         });

//         setMessages(processedMessages);

//         if (!receiverId && selectedConversation?.other_user?.id) {
//           const otherUserId = selectedConversation.other_user.id;
//           setLocalReceiverId(otherUserId);
//           checkOtherUserOnlineStatus(otherUserId);
//           try {
//             dispatch(setReceiverId(otherUserId));
//           } catch (err) {
//             console.error('Error updating Redux receiver ID:', err);
//           }
//         }

//         markMessagesAsRead(conversationId);
//       } else {
//         console.error('Messages API returned non-200 status code:', data.statusCode);
//         throw new Error(data.message || 'Failed to fetch messages');
//       }
//     } catch (err) {
//       console.error('Error fetching messages:', err);
//       console.error('Error details:', err.message);
//       setMessageError('Failed to load messages. Please try again later.');
//       setMessages([]);
//     } finally {
//       setLoadingMessages(false);
//     }
//   };

//   const sendMessage = async (messageText) => {
//     if (!messageText.trim()) {
//       console.log('Message text is empty');
//       return;
//     }

//     if (!currentConversationId) {
//       console.log('Missing conversation ID');
//       return;
//     }

//     if (!userId) {
//       console.log('Missing user ID');
//       return;
//     }

//     let actualReceiverId = receiverId;
//     if (!actualReceiverId && selectedConversation?.other_user?.id) {
//       actualReceiverId = selectedConversation.other_user.id;
//       setLocalReceiverId(actualReceiverId);
//       checkOtherUserOnlineStatus(actualReceiverId);
//       try {
//         dispatch(setReceiverId(actualReceiverId));
//       } catch (err) {
//         console.error('Error updating Redux receiver ID:', err);
//       }
//     }

//     if (!actualReceiverId) {
//       console.log('Missing receiver ID and cannot determine from conversation');
//       return;
//     }

//     setSendingMessage(true);

//     try {
//       let initialStatus = 'sent';
//       if (otherUserOnlineStatus) {
//         initialStatus = 'read';
//       } else if (otherUserLoggedInStatus) {
//         initialStatus = 'delivered';
//       }

//       const tempMessage = {
//         message_id: `temp-${Date.now()}`,
//         message_text: messageText,
//         sender_id: userId,
//         sender_name: user?.full_name || 'You',
//         receiver_id: actualReceiverId,
//         receiver_name: 'Receiver',
//         timestamp: new Date().toISOString(),
//         status: initialStatus
//       };

//       setMessages(prevMessages => [...prevMessages, tempMessage]);
//       setInputMessage('');

//       const apiUrl = 'https://propertydealstalk.com/api/messaging/sendMessage';
//       console.log('Send Message API URL:', apiUrl);

//       const requestBody = {
//         conversation_id: currentConversationId,
//         receiver_id: actualReceiverId,
//         sender_id: userId,
//         message_text: messageText
//       };

//       console.log('Sending message with data:', requestBody);

//       const response = await fetch(apiUrl, {
//         method: 'POST',
//         headers: {
//           'Accept': 'application/json',
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify(requestBody)
//       });

//       if (!response.ok) {
//         console.error('Send message API response not OK:', response.status, response.statusText);
//         throw new Error(`Send message API request failed with status ${response.status}`);
//       }

//       const data = await response.json();
//       console.log('Send message API response:', data);

//       if (data.statusCode === 200) {
//         console.log('Message sent successfully:', data.result);

//         setMessages(prevMessages =>
//           prevMessages.map(msg =>
//             msg.message_id === tempMessage.message_id
//               ? {
//                   ...msg,
//                   message_id: data.result.message_id,
//                   timestamp: data.result.timestamp,
//                   status: initialStatus
//                 }
//               : msg
//           )
//         );
//       } else {
//         console.error('Send message API returned non-200 status code:', data.statusCode);
//         throw new Error(data.message || 'Failed to send message');
//       }
//     } catch (err) {
//       console.error('Error sending message:', err);
//       console.error('Error details:', err.message);

//       setMessages(prevMessages =>
//         prevMessages.map(msg =>
//           msg.status === 'sending'
//             ? { ...msg, status: 'failed' }
//             : msg
//         )
//       );
//     } finally {
//       setSendingMessage(false);
//     }
//   };

//   const handleConversationSelect = (conversation) => {
//     setSelectedConversation(conversation);
//     setLocalCurrentConversationId(conversation.conversation_id);

//     if (conversation.other_user && conversation.other_user.id) {
//       const otherUserId = conversation.other_user.id;
//       setLocalReceiverId(otherUserId);
//       checkOtherUserOnlineStatus(otherUserId);
//       try {
//         dispatch(setReceiverId(otherUserId));
//       } catch (err) {
//         console.error('Error updating Redux receiver ID:', err);
//       }
//     }

//     try {
//       dispatch(setCurrentConversationId(conversation.conversation_id));
//       if (conversation.other_user && conversation.other_user.id) {
//         dispatch(setSenderId(conversation.other_user.id));
//       }
//     } catch (err) {
//       console.error('Error updating Redux state:', err);
//     }

//     fetchMessages(conversation.conversation_id);
//     markMessagesAsRead(conversation.conversation_id);
//   };

//   const formatRelativeTime = (timestamp) => {
//     if (!timestamp) return '';

//     try {
//       const now = new Date();
//       const messageTime = new Date(timestamp);

//       if (isNaN(messageTime.getTime())) {
//         console.error('Invalid date:', timestamp);
//         return 'Invalid date';
//       }

//       const diffInMs = now - messageTime;
//       const diffInMinutes = Math.floor(diffInMs / (1000 * 60));

//       if (diffInMinutes < 1) return 'just now';
//       if (diffInMinutes < 60) return `${diffInMinutes}m ago`;

//       const diffInHours = Math.floor(diffInMinutes / 60);
//       if (diffInHours < 24) return `${diffInHours}h ago`;

//       const diffInDays = Math.floor(diffInHours / 24);
//       if (diffInDays < 7) return `${diffInDays}d ago`;

//       return messageTime.toLocaleDateString();
//     } catch (error) {
//       console.error('Error formatting date:', error);
//       return 'Date error';
//     }
//   };

//   const formatMessageTime = (timestamp) => {
//     if (!timestamp) return '';

//     try {
//       const date = new Date(timestamp);

//       if (isNaN(date.getTime())) {
//         return 'Invalid time';
//       }

//       return date.toLocaleTimeString('en-US', {
//         hour: 'numeric',
//         minute: '2-digit',
//         hour12: true
//       });
//     } catch (error) {
//       console.error('Error formatting time:', error);
//       return 'Time error';
//     }
//   };

//   const getMessageStatusIcon = (status, isSentByCurrentUser) => {
//     if (!isSentByCurrentUser) return null;

//     switch (status) {
//       case 'sent':
//         return <div dangerouslySetInnerHTML={{ __html: singleTickSvg }} />;
//       case 'delivered':
//         return <div dangerouslySetInnerHTML={{ __html: doubleTickSvg }} />;
//       case 'read':
//         return <div dangerouslySetInnerHTML={{ __html: doubleTickBlueSvg }} />;
//       case 'failed':
//         return <Typography sx={{ color: 'red', fontSize: '10px' }}>Failed</Typography>;
//       default:
//         return <div dangerouslySetInnerHTML={{ __html: singleTickSvg }} />;
//     }
//   };

//   if (!userId) {
//     return (
//       <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '300px', flexDirection: 'column', gap: 2 }}>
//         <Typography variant="h6">Please log in to view your messages</Typography>
//         <Typography variant="body2" color="text.secondary">
//           You need to be logged in to access your conversations
//         </Typography>
//       </Box>
//     );
//   }

//   if (loading) return <Loader />;

//   return (
//     <Box
//       sx={{
//         flex: 1,
//         display: 'flex',
//         flexDirection: { xs: 'column', md: 'row' },
//         gap: { xs: '10px', md: '20px' },
//         width: '100%',
//       }}
//     >
//       {/* Inbox List */}
//       <Box
//         sx={{
//           width: { xs: '100%', md: '320px' },
//           background: '#fff',
//           borderRadius: '8px',
//           display: 'flex',
//           flexDirection: 'column',
//           overflowY: 'auto',
//           padding: { xs: '12px', md: '46px 16px 0 16px' }, // ✅ Fixed: Reduced mobile top padding from 20px to 12px
//         }}
//       >
//         {error ? (
//           <Box sx={{ padding: '20px', textAlign: 'center' }}>
//             <Typography sx={{ color: 'red', marginBottom: '10px' }}>
//               Error: Failed to fetch. Please try again later.
//             </Typography>
//           </Box>
//         ) : conversations.length > 0 ? (
//           conversations.map((conversation) => (
//             <Box
//               key={conversation.conversation_id}
//               sx={{
//                 display: 'flex',
//                 alignItems: 'flex-start',
//                 padding: '10px',
//                 border: '2px solid #f1f1f1',
//                 borderRadius: '9px',
//                 cursor: 'pointer',
//                 marginBottom: '12px', // ✅ Fixed: Reduced from 20px to 12px for better spacing
//                 backgroundColor: selectedConversation?.conversation_id === conversation.conversation_id ? '#f8f9fa' : 'transparent',
//               }}
//               onClick={() => handleConversationSelect(conversation)}
//             >
//               <img
//                 src={conversation.property.image}
//                 alt="Property"
//                 style={{
//                   width: '40px',
//                   height: '38px',
//                   borderRadius: '8px',
//                   marginRight: '12px',
//                   objectFit: 'cover',
//                 }}
//                 onError={(e) => {
//                   console.warn('Image failed to load, using fallback');
//                   e.target.src = propertyImage;
//                 }}
//               />
//               <Box sx={{ flex: 1 }}>
//                 <Box
//                   sx={{
//                     display: 'flex',
//                     justifyContent: 'space-between',
//                     alignItems: 'flex-start',
//                   }}
//                 >
//                   <Typography sx={{ margin: 0, fontSize: '13px', fontWeight: 600 }}>
//                     {conversation.property.property_name}
//                   </Typography>
//                   <Box
//                     sx={{
//                       display: 'flex',
//                       flexDirection: 'column',
//                       alignItems: 'flex-end',
//                     }}
//                   >
//                     {conversation.last_message.status !== 'read' && (
//                       <Box
//                         sx={{
//                           width: '8px',
//                           height: '8px',
//                           background: 'red',
//                           borderRadius: '50%',
//                         }}
//                       />
//                     )}
//                     <Typography sx={{ fontSize: '11px', color: '#888', marginTop: '4px' }}>
//                       {formatRelativeTime(conversation.last_message_time)}
//                     </Typography>
//                   </Box>
//                 </Box>
//                 <Typography sx={{ margin: '4px 0 0', fontSize: '12px', color: '#555' }}>
//                   {conversation.last_message.message_text}
//                 </Typography>
//               </Box>
//             </Box>
//           ))
//         ) : (
//           <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
//             <Typography sx={{ color: '#888', fontSize: '14px' }}>
//               No conversations yet
//             </Typography>
//           </Box>
//         )}
//       </Box>

//       {/* Chatbox */}
//       <Box
//         sx={{
//           flex: 1,
//           display: 'flex',
//           flexDirection: 'column',
//           background: '#fff',
//           borderRadius: '8px',
//           maxWidth: { md: '660px', xs: '100%' },
//           width: '100%',
//         }}
//       >
//         {/* Header section */}
//         {selectedConversation && selectedConversation.property ? (
//           <Box
//             sx={{
//               display: 'flex',
//               flexDirection: { xs: 'column', md: 'row' },
//               alignItems: 'flex-start',
//               padding: { xs: '12px', md: '25px 9px 0 9px' },
//               borderBottom: '2px solid #eee',
//               height: { xs: 'auto', md: '110px' },
//             }}
//           >
//             <img
//               src={selectedConversation.property.image}
//               alt="Property"
//               style={{
//                 width: '140px',
//                 height: '70px',
//                 borderRadius: '8px',
//                 marginRight: '22px',
//                 marginLeft: '20px',
//                 objectFit: 'cover',
//               }}
//               onError={(e) => {
//                 console.warn('Header image failed to load, using fallback');
//                 e.target.src = inboxheader;
//               }}
//             />
//             <Box>
//               <Typography sx={{ margin: 0, fontSize: '15px', fontWeight: 600 }}>
//                 {selectedConversation.property.property_name}
//               </Typography>
//               <Typography
//                 sx={{
//                   margin: '8px 0',
//                   fontSize: '16px',
//                   fontWeight: 600,
//                   color: '#2563eb'
//                 }}
//               >
//                 {selectedConversation.property.category === 'sale' 
//                   ? `${selectedConversation.property.currency}${selectedConversation.property.asking_price || 'N/A'}`
//                   : `${selectedConversation.property.currency}${selectedConversation.property.monthly_rent || 'N/A'}/month`
//                 }
//               </Typography>
//               <Typography sx={{ margin: 0, fontSize: '12px', color: '#444' }}>
//                 {selectedConversation.property.location}
//               </Typography>
//             </Box>
//             <Typography
//               sx={{
//                 marginLeft: 'auto',
//                 fontSize: '14px',
//                 color: selectedConversation.is_other_user_online || otherUserOnlineStatus ? 'green' : '#888',
//                 alignSelf: 'flex-end',
//                 marginBottom: '6px',
//               }}
//             >
//               ● {selectedConversation.is_other_user_online || otherUserOnlineStatus ? 'Online' : 'Offline'}
//             </Typography>
//           </Box>
//         ) : (
//           <Box
//             sx={{
//               display: 'flex',
//               justifyContent: 'center',
//               alignItems: 'center',
//               width: '100%',
//               height: '110px',
//               borderBottom: '2px solid #eee',
//             }}
//           >
//             <Typography sx={{ color: '#888', fontSize: '14px' }}>
//               Select a conversation
//             </Typography>
//           </Box>
//         )}

//         {/* Messages */}
//         {selectedConversation ? (
//           <>
//             <Box
//               sx={{
//                 flex: 1,
//                 padding: { xs: '16px', md: '24px' }, // ✅ Fixed: Reduced mobile padding from 24px to 16px
//                 display: 'flex',
//                 flexDirection: 'column',
//                 gap: { xs: '16px', md: '28px' }, // ✅ Fixed: Reduced mobile gap from 28px to 16px
//                 overflowY: 'auto',
//               }}
//             >
//               {loadingMessages ? (
//                 <Box sx={{ display: 'flex', justifyContent: 'center', padding: '20px' }}>
//                   <CircularProgress size={24} />
//                 </Box>
//               ) : messageError ? (
//                 <Box sx={{ padding: '20px', textAlign: 'center' }}>
//                   <Typography sx={{ color: 'red', marginBottom: '10px' }}>
//                     {messageError}
//                   </Typography>
//                 </Box>
//               ) : messages.length > 0 ? (
//                 messages.map((message) => {
//                   const isSentByCurrentUser = message.sender_id === userId;
//                   return (
//                     <Box
//                       key={message.message_id}
//                       sx={{
//                         display: 'flex',
//                         alignItems: 'flex-start',
//                         maxWidth: '100%',
//                         flexDirection: isSentByCurrentUser ? 'row-reverse' : 'row',
//                         alignSelf: isSentByCurrentUser ? 'flex-end' : 'flex-start',
//                       }}
//                     >
//                       <Avatar
//                         sx={{
//                           width: { xs: 30, md: 52 },
//                           height: { xs: 30, md: 52 },
//                           bgcolor: isSentByCurrentUser ? '#2563eb' : '#9ca3af',
//                         }}
//                       >
//                         <AccountCircle sx={{ width: '100%', height: '100%' }} />
//                       </Avatar>
//                       <Box
//                         sx={{
//                           display: 'flex',
//                           flexDirection: 'column',
//                           marginLeft: isSentByCurrentUser ? 0 : '10px',
//                           marginRight: isSentByCurrentUser ? '10px' : 0,
//                           alignItems: isSentByCurrentUser ? 'flex-end' : 'flex-start',
//                         }}
//                       >
//                         <Typography
//                           sx={{
//                             fontSize: { xs: '12px', md: '13px' },
//                             fontWeight: 600,
//                             marginBottom: '4px',
//                             color: '#2563eb',
//                             textAlign: isSentByCurrentUser ? 'right' : 'left',
//                           }}
//                         >
//                           {message.sender_name}
//                         </Typography>
//                         <Box
//                           sx={{
//                             background: isSentByCurrentUser ? '#2563eb' : '#f1f5f9',
//                             color: isSentByCurrentUser ? '#fff' : '#000',
//                             borderRadius: '10px',
//                             padding: { xs: '8px 12px', md: '12px 16px' },
//                             fontSize: { xs: '12px', md: '13px' },
//                           }}
//                         >
//                           {message.message_text}
//                         </Box>
//                         <Box
//                           sx={{
//                             fontSize: { xs: '10px', md: '11px' },
//                             color: '#888',
//                             marginTop: '8px',
//                             display: 'flex',
//                             alignItems: 'center',
//                             gap: '4px',
//                             justifyContent: isSentByCurrentUser ? 'flex-end' : 'flex-start',
//                           }}
//                         >
//                           {formatMessageTime(message.timestamp)}
//                           {getMessageStatusIcon(message.status, isSentByCurrentUser)}
//                         </Box>
//                       </Box>
//                     </Box>
//                   );
//                 })
//               ) : (
//                 <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
//                   <Typography sx={{ color: '#888', fontSize: '14px' }}>
//                     No messages yet. Start the conversation!
//                   </Typography>
//                 </Box>
//               )}
//             </Box>

//             {/* Input */}
//             <Box
//               sx={{
//                 display: 'flex',
//                 alignItems: 'center',
//                 padding: '12px 16px',
//                 borderTop: '1px solid #eee',
//                 background: '#fff',
//               }}
//             >
//               <Box sx={{ display: 'flex', alignItems: 'center', gap: '12px', marginRight: '12px' }}>
//                 {[attachIcon, photoIcon, locationIcon].map((icon, idx) => (
//                   <Box
//                     key={idx}
//                     component="img"
//                     src={icon}
//                     sx={{ width: '32px', height: '30px', cursor: 'pointer' }}
//                   />
//                 ))}
//               </Box>
//               <InputBase
//                 placeholder="Type your message"
//                 value={inputMessage}
//                 onChange={(e) => setInputMessage(e.target.value)}
//                 onKeyPress={(e) => {
//                   if (e.key === 'Enter' && !e.shiftKey) {
//                     e.preventDefault();
//                     if (inputMessage.trim()) {
//                       sendMessage(inputMessage);
//                     }
//                   }
//                 }}
//                 sx={{
//                   flex: 1,
//                   padding: '10px 16px',
//                   borderRadius: '20px',
//                   border: '1px solid #ddd',
//                   background: '#f1f5f9',
//                   fontSize: '14px',
//                 }}
//               />
//               <IconButton
//                 sx={{ paddingLeft: '10px' }}
//                 onClick={() => {
//                   if (inputMessage.trim()) {
//                     sendMessage(inputMessage);
//                   }
//                 }}
//                 disabled={sendingMessage}
//               >
//                 <Box component="img" src={sendIcon} sx={{ width: '26px', height: '26px' }} />
//               </IconButton>
//             </Box>
//           </>
//         ) : (
//           <Box
//             sx={{
//               display: 'flex',
//               justifyContent: 'center',
//               alignItems: 'center',
//               height: '100%',
//               flexDirection: 'column',
//               padding: '20px'
//             }}
//           >
//             <Typography variant="h6" sx={{ color: '#555', marginBottom: '10px' }}>
//               Select a conversation
//             </Typography>
//             <Typography variant="body2" color="text.secondary" sx={{ textAlign: 'center' }}>
//               Choose a conversation from the list to start chatting
//             </Typography>
//           </Box>
//         )}
//       </Box>
//     </Box>
//   );
// };

// export default ProfileInbox;


import React, { useState, useEffect, useCallback, useRef } from 'react';
import { Box, Typography, InputBase, IconButton, Avatar, CircularProgress } from '@mui/material';
import { useSelector } from 'react-redux';
import { AccountCircle, Check, DoneAll } from '@mui/icons-material';
import socketService from '../services/socketService';
import socketEvents from '../services/socketEvents';

// Asset Imports
import propertyImage from '../assets/inmenu.png';
import sendIcon from '../assets/rocket.png';
import inboxheader from '../assets/inhead.png';
import Loader from '../Loader/Loader';

const SingleTick = ({ color = '#888' }) => (
  <Check sx={{ fontSize: '14px', color }} />
);

const DoubleTick = ({ color = '#888' }) => (
  <DoneAll sx={{ fontSize: '14px', color }} />
);

const ProfileInbox = () => {
  const [conversations, setConversations] = useState([]);
  const [messages, setMessages] = useState([]);
  const [selectedConversation, setSelectedConversation] = useState(null);
  const [inputMessage, setInputMessage] = useState('');
  const [loading, setLoading] = useState(true);
  const [messagesLoading, setMessagesLoading] = useState(false);
  const [socketConnected, setSocketConnected] = useState(false);
  const [onlineUsers, setOnlineUsers] = useState(new Set());

  const user = useSelector((state) => state.user.user);
  const userId = user?.id;

  const socketInitializedRef = useRef(false);
  const messagesEndRef = useRef(null);
  const currentConversationRef = useRef(null);
  const reconnectionTimeoutRef = useRef(null);
  const disconnectCountRef = useRef(0);
  const lastDisconnectRef = useRef(0);
  
  const timeoutsRef = useRef([]);
  const loadingMessagesRef = useRef(false);

  const clearAllTimeouts = useCallback(() => {
    timeoutsRef.current.forEach(timeoutId => clearTimeout(timeoutId));
    timeoutsRef.current = [];
  }, []);

  const addTimeout = useCallback((callback, delay) => {
    const timeoutId = setTimeout(() => {
      callback();
      timeoutsRef.current = timeoutsRef.current.filter(id => id !== timeoutId);
    }, delay);
    timeoutsRef.current.push(timeoutId);
    return timeoutId;
  }, []);

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  useEffect(() => {
    scrollToBottom();
  }, [messages]);

  const formatIndianPrice = (price) => {
    if (!price) return 'N/A';
    
    const numPrice = typeof price === 'string' ? parseFloat(price.replace(/,/g, '')) : price;
    if (isNaN(numPrice)) return 'N/A';
    
    const priceStr = Math.round(numPrice).toString();
    let result = '';
    let count = 0;
    
    for (let i = priceStr.length - 1; i >= 0; i--) {
      if (count === 3 || (count > 3 && (count - 3) % 2 === 0)) {
        result = ',' + result;
      }
      result = priceStr[i] + result;
      count++;
    }
    
    return result;
  };

  const convertBase64ToImageUrl = (base64String) => {
    if (!base64String) return null;
    if (base64String.startsWith('data:image')) return base64String;
    if (base64String.startsWith('/9j/') || base64String.startsWith('iVBOR')) {
      return `data:image/jpeg;base64,${base64String}`;
    }
    return null;
  };

  const formatRelativeTime = (timestamp) => {
    if (!timestamp) return '';
    try {
      const now = new Date();
      const messageTime = new Date(timestamp);
      if (isNaN(messageTime.getTime())) return '';
      const diffInMs = now - messageTime;
      const diffInMinutes = Math.floor(diffInMs / (1000 * 60));
      if (diffInMinutes < 1) return 'just now';
      if (diffInMinutes < 60) return `${diffInMinutes}m ago`;
      const diffInHours = Math.floor(diffInMinutes / 60);
      if (diffInHours < 24) return `${diffInHours}h ago`;
      const diffInDays = Math.floor(diffInHours / 24);
      if (diffInDays < 7) return `${diffInDays}d ago`;
      return messageTime.toLocaleDateString();
    } catch (error) {
      return '';
    }
  };

  const formatMessageTime = (timestamp) => {
    if (!timestamp) return '';
    try {
      const date = new Date(timestamp);
      if (isNaN(date.getTime())) return '';
      return date.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', hour12: true });
    } catch (error) {
      return '';
    }
  };

  const getMessageStatusIcon = (status, isSentByCurrentUser) => {
    if (!isSentByCurrentUser) return null;

    switch (status) {
      case 'sent':
        return <SingleTick color="#888" />;
      case 'delivered':
      case 'received':
        return <DoubleTick color="#888" />;
      case 'read':
        return <DoubleTick color="#2563eb" />;
      case 'failed':
        return <Typography sx={{ color: 'red', fontSize: '10px' }}>!</Typography>;
      default:
        return <SingleTick color="#888" />;
    }
  };

  const fetchConversations = useCallback(async () => {
    if (!userId) return;

    try {
      const response = await fetch(
        `https://propertydealstalk.com/api/messaging/conversations?user_id=${userId}`,
        {
          method: 'GET',
          headers: { 
            'Content-Type': 'application/json',
            'Cache-Control': 'no-cache'
          }
        }
      );

      if (response.ok) {
        const data = await response.json();
        if (data.statusCode === 200 && data.result) {
          const processed = data.result.map(conv => ({
            ...conv,
            property: {
              ...conv.property,
              image: convertBase64ToImageUrl(conv.property?.image) || propertyImage
            }
          }));
          setConversations(processed);
        }
      }
      setLoading(false);
    } catch (error) {
      console.error('Error fetching conversations:', error);
      setLoading(false);
    }
  }, [userId]);

  const loadMessagesViaSocket = useCallback((conversationId) => {
    if (!conversationId || !userId) return;

    if (loadingMessagesRef.current) {
      return;
    }

    if (!socketService.isSocketConnected()) {
      setMessagesLoading(false);
      return;
    }

    loadingMessagesRef.current = true;
    setMessagesLoading(true);

    socketEvents.joinConversation(conversationId);

    addTimeout(() => {
      if (socketService.isSocketConnected()) {
        socketEvents.getMessages(conversationId, userId);
        
        addTimeout(() => {
          if (socketService.isSocketConnected()) {
            socketEvents.markMessagesAsRead(conversationId, userId);
          }
        }, 500);
      }
    }, 500);

    addTimeout(() => {
      if (loadingMessagesRef.current) {
        setMessagesLoading(false);
        loadingMessagesRef.current = false;
      }
    }, 8000);

  }, [userId, addTimeout]);

  const selectConversation = useCallback((conversation) => {
    clearAllTimeouts();
    loadingMessagesRef.current = false;

    setSelectedConversation(conversation);
    currentConversationRef.current = conversation;
    setMessages([]);
    setMessagesLoading(true);

    if (socketService.isSocketConnected()) {
      loadMessagesViaSocket(conversation.conversation_id);
    } else {
      setMessagesLoading(false);
    }
  }, [loadMessagesViaSocket, clearAllTimeouts]);

  useEffect(() => {
    if (!userId) return;
    
    if (socketInitializedRef.current) {
      return;
    }

    socketInitializedRef.current = true;

    const initSocket = async () => {
      try {
        await socketService.connect('https://propertydealstalk.com', {
          transports: ['websocket', 'polling'],
          autoConnect: true,
          reconnection: true,
          reconnectionAttempts: 10,
          reconnectionDelay: 2000,
          reconnectionDelayMax: 10000,
          timeout: 30000
        });

        setSocketConnected(true);

        const socket = socketService.getSocket();

        socket.io.on('reconnect', () => {
          setSocketConnected(true);
          
          if (reconnectionTimeoutRef.current) {
            clearTimeout(reconnectionTimeoutRef.current);
          }
          
          reconnectionTimeoutRef.current = setTimeout(() => {
            if (!socketService.isSocketConnected()) {
              return;
            }

            socketEvents.userConnected(userId);
            
            if (currentConversationRef.current && !loadingMessagesRef.current) {
              addTimeout(() => {
                if (socketService.isSocketConnected() && !loadingMessagesRef.current) {
                  loadMessagesViaSocket(currentConversationRef.current.conversation_id);
                }
              }, 1000);
            }
          }, 2000);
        });

        socket.on('disconnect', (reason) => {
          const now = Date.now();
          
          if (now - lastDisconnectRef.current < 5000) {
            disconnectCountRef.current++;
          } else {
            disconnectCountRef.current = 1;
          }
          
          lastDisconnectRef.current = now;
          setSocketConnected(false);
          
          if (disconnectCountRef.current > 5) {
            socketService.disconnect();
            socketInitializedRef.current = false;
          }
        });

        socketEvents.registerEvents({
          onUserConnected: (data) => {
            console.log('User connected');
          },

          onMessagesList: (data) => {
            setMessagesLoading(false);
            loadingMessagesRef.current = false;
            clearAllTimeouts();
            
            if (Array.isArray(data)) {
              setMessages(data);
            } else if (data && Array.isArray(data.result)) {
              setMessages(data.result);
            } else {
              setMessages([]);
            }
            scrollToBottom();
          },

          onMessageSent: (data) => {
            setMessages(prev => {
              const filtered = prev.filter(msg => !msg.id?.toString().startsWith('temp-'));
              return [...filtered, data];
            });
            scrollToBottom();
          },

          onMessageReceived: (messageId) => {
            if (currentConversationRef.current && socketService.isSocketConnected()) {
              addTimeout(() => {
                socketEvents.getMessages(currentConversationRef.current.conversation_id, userId);
              }, 500);
            }
          },

          onMessageDelivered: (data) => {
            if (data.message_id) {
              setMessages(prev =>
                prev.map(msg =>
                  msg.id === data.message_id ? { ...msg, status: 'delivered' } : msg
                )
              );
            }
          },

          onMessagesRead: (data) => {
            if (data.message_ids && Array.isArray(data.message_ids)) {
              setMessages(prev =>
                prev.map(msg =>
                  data.message_ids.includes(msg.id) ? { ...msg, status: 'read' } : msg
                )
              );
            }
          },

          onNewConversation: (data) => {
            fetchConversations();
          },

          onJoinedConversation: (data) => {
            console.log('Joined conversation');
          },

          onUserOnline: (data) => {
            if (data.user_id) {
              setOnlineUsers(prev => new Set([...prev, data.user_id]));
            }
          },

          onUserOffline: (data) => {
            if (data.user_id) {
              setOnlineUsers(prev => {
                const newSet = new Set(prev);
                newSet.delete(data.user_id);
                return newSet;
              });
            }
          }
        });

        addTimeout(() => {
          if (socketService.isSocketConnected()) {
            socketEvents.userConnected(userId);
          }
        }, 1500);

        addTimeout(() => {
          fetchConversations();
        }, 1000);

      } catch (error) {
        console.error('Socket initialization failed:', error);
        setSocketConnected(false);
        await fetchConversations();
      }
    };

    initSocket();

    return () => {
      clearAllTimeouts();
      if (reconnectionTimeoutRef.current) {
        clearTimeout(reconnectionTimeoutRef.current);
      }
      socketEvents.unregisterEvents();
      socketService.disconnect();
      socketInitializedRef.current = false;
      loadingMessagesRef.current = false;
    };
  }, [userId, addTimeout, clearAllTimeouts, fetchConversations, loadMessagesViaSocket]);

  const sendMessage = useCallback(() => {
    if (!inputMessage.trim() || !selectedConversation || !userId) return;

    const receiverId = selectedConversation.other_user?.id || selectedConversation.other_user_id;
    if (!receiverId) {
      return;
    }

    const tempMessage = {
      id: `temp-${Date.now()}`,
      conversation_id: selectedConversation.conversation_id,
      sender_id: userId,
      receiver_id: receiverId,
      message_text: inputMessage,
      timestamp: new Date().toISOString(),
      status: 'sent'
    };

    setMessages(prev => [...prev, tempMessage]);
    scrollToBottom();

    socketEvents.sendMessage(
      selectedConversation.conversation_id,
      userId,
      receiverId,
      inputMessage
    );

    setInputMessage('');
  }, [inputMessage, selectedConversation, userId]);

  const handleInputChange = useCallback((e) => {
    setInputMessage(e.target.value);
  }, []);

  if (!userId) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '300px', flexDirection: 'column', gap: 2 }}>
        <Typography variant="h6">Please log in to view your messages</Typography>
      </Box>
    );
  }

  if (loading) {
    return <Loader />;
  }

  return (
    <Box sx={{ 
      flex: 1, 
      display: 'flex', 
      flexDirection: { xs: 'column', md: 'row' }, 
      gap: { xs: '10px', md: '20px' }, 
      width: '100%',
      height: { xs: 'auto', md: 'calc(100vh - 150px)' },
      maxHeight: { xs: 'none', md: 'calc(100vh - 150px)' }
    }}>
      {/* Inbox List */}
      <Box sx={{ 
        width: { xs: '100%', md: '320px' }, 
        background: '#fff', 
        borderRadius: '8px', 
        display: 'flex', 
        flexDirection: 'column',
        maxHeight: { xs: '400px', md: '100%' },
        height: { xs: '400px', md: '100%' }
      }}>
        <Box sx={{ 
          overflowY: 'auto', 
          flex: 1, 
          padding: { xs: '12px', md: '16px' },
          WebkitOverflowScrolling: 'touch',
          '&::-webkit-scrollbar': { width: '6px' },
          '&::-webkit-scrollbar-track': { background: '#f1f1f1' },
          '&::-webkit-scrollbar-thumb': { background: '#888', borderRadius: '3px' },
          '&::-webkit-scrollbar-thumb:hover': { background: '#555' }
        }}>
          {conversations.length > 0 ? (
            conversations.map((conv) => (
              <Box
                key={conv.conversation_id}
                onClick={() => selectConversation(conv)}
                sx={{
                  display: 'flex', 
                  alignItems: 'flex-start', 
                  padding: '10px', 
                  border: '2px solid #f1f1f1',
                  borderRadius: '9px', 
                  cursor: 'pointer', 
                  marginBottom: '12px',
                  backgroundColor: selectedConversation?.conversation_id === conv.conversation_id ? '#f8f9fa' : 'transparent',
                  '&:hover': { backgroundColor: '#f8f9fa' }
                }}
              >
                <img 
                  src={conv.property?.image || propertyImage} 
                  alt="Property" 
                  style={{ width: '40px', height: '38px', borderRadius: '8px', marginRight: '12px', objectFit: 'cover' }}
                  onError={(e) => { e.target.src = propertyImage; }}
                />
                <Box sx={{ flex: 1 }}>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                    <Typography sx={{ fontSize: '13px', fontWeight: 600 }}>
                      {conv.property?.property_name || 'Property'}
                    </Typography>
                    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
                      {conv.last_message?.status !== 'read' && (
                        <Box sx={{ width: '8px', height: '8px', background: 'red', borderRadius: '50%', marginBottom: '4px' }} />
                      )}
                      <Typography sx={{ fontSize: '11px', color: '#888' }}>
                        {formatRelativeTime(conv.last_message_time)}
                      </Typography>
                    </Box>
                  </Box>
                  <Typography sx={{ fontSize: '12px', color: '#555', marginTop: '4px' }}>
                    {conv.last_message?.message_text || 'No messages'}
                  </Typography>
                </Box>
              </Box>
            ))
          ) : (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
              <Typography sx={{ color: '#888', fontSize: '14px' }}>No conversations yet</Typography>
            </Box>
          )}
        </Box>
      </Box>

      {/* ✅ MOBILE SCROLLING FIXED: Added fixed height and overflow for mobile */}
      <Box sx={{ 
        flex: 1, 
        display: 'flex', 
        flexDirection: 'column', 
        background: '#fff', 
        borderRadius: '8px', 
        maxWidth: { md: '660px', xs: '100%' }, 
        width: '100%',
        height: { xs: '600px', md: '100%' },
        maxHeight: { xs: '600px', md: '100%' },
        overflow: 'hidden'
      }}>
        {selectedConversation ? (
          <>
            <Box sx={{ 
              display: 'flex', 
              flexDirection: { xs: 'column', md: 'row' }, 
              alignItems: 'flex-start', 
              padding: { xs: '12px', md: '25px 9px 0 9px' }, 
              borderBottom: '2px solid #eee', 
              minHeight: { xs: 'auto', md: '110px' },
              flexShrink: 0
            }}>
              <img 
                src={selectedConversation.property?.image || propertyImage} 
                alt="Property" 
                style={{ width: '140px', height: '70px', borderRadius: '8px', marginRight: '22px', marginLeft: '20px', objectFit: 'cover' }}
                onError={(e) => { e.target.src = inboxheader; }}
              />
              <Box sx={{ flex: 1 }}>
                <Typography sx={{ fontSize: '15px', fontWeight: 600 }}>
                  {selectedConversation.property?.property_name || 'Property'}
                </Typography>
                <Typography sx={{ margin: '8px 0', fontSize: '16px', fontWeight: 600, color: '#2563eb' }}>
                  {selectedConversation.property?.category === 'sale' 
                    ? `${selectedConversation.property?.currency || '₹'}${formatIndianPrice(selectedConversation.property?.asking_price)}`
                    : `${selectedConversation.property?.currency || '₹'}${formatIndianPrice(selectedConversation.property?.monthly_rent)}/month`
                  }
                </Typography>
                <Typography sx={{ fontSize: '12px', color: '#444' }}>
                  {selectedConversation.property?.location || 'Location'}
                </Typography>
              </Box>
              <Box sx={{ marginLeft: 'auto', display: 'flex', flexDirection: 'column', alignItems: 'flex-end', alignSelf: 'flex-end', marginBottom: '6px' }}>
                <Typography sx={{ 
                  fontSize: '14px', 
                  color: onlineUsers.has(selectedConversation.other_user?.id || selectedConversation.other_user_id) ? 'green' : '#888'
                }}>
                  ● {onlineUsers.has(selectedConversation.other_user?.id || selectedConversation.other_user_id) ? 'Online' : 'Offline'}
                </Typography>
              </Box>
            </Box>

            {/* ✅ MOBILE SCROLLING: Now properly configured */}
            <Box sx={{ 
              flex: 1, 
              padding: { xs: '16px', md: '24px' }, 
              display: 'flex', 
              flexDirection: 'column', 
              gap: { xs: '12px', md: '16px' }, 
              overflowY: 'auto',
              overflowX: 'hidden',
              minHeight: 0,
              maxHeight: '100%',
              WebkitOverflowScrolling: 'touch',
              scrollBehavior: 'smooth',
              '&::-webkit-scrollbar': { width: '6px' },
              '&::-webkit-scrollbar-track': { background: '#f1f1f1' },
              '&::-webkit-scrollbar-thumb': { 
                background: '#888', 
                borderRadius: '3px',
                '&:hover': { background: '#555' }
              }
            }}>
              {messagesLoading ? (
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                  <CircularProgress size={40} />
                </Box>
              ) : messages.length > 0 ? (
                <>
                  {messages.map((msg, idx) => {
                    const isMe = msg.sender_id === userId;
                    return (
                      <Box 
                        key={msg.id || idx} 
                        sx={{ 
                          display: 'flex', 
                          alignItems: 'flex-start', 
                          flexDirection: isMe ? 'row-reverse' : 'row',
                          maxWidth: '80%',
                          alignSelf: isMe ? 'flex-end' : 'flex-start',
                          flexShrink: 0
                        }}
                      >
                        <Avatar sx={{ 
                          width: { xs: 32, md: 40 }, 
                          height: { xs: 32, md: 40 }, 
                          bgcolor: isMe ? '#2563eb' : '#9ca3af',
                          flexShrink: 0
                        }}>
                          <AccountCircle sx={{ width: '100%', height: '100%' }} />
                        </Avatar>
                        <Box sx={{ 
                          display: 'flex', 
                          flexDirection: 'column', 
                          marginLeft: isMe ? 0 : '10px', 
                          marginRight: isMe ? '10px' : 0,
                          alignItems: isMe ? 'flex-end' : 'flex-start',
                          maxWidth: '100%'
                        }}>
                          <Typography sx={{ 
                            fontSize: '11px', 
                            fontWeight: 600, 
                            marginBottom: '4px', 
                            color: '#2563eb' 
                          }}>
                            {isMe ? 'You' : (selectedConversation.other_user?.full_name || 'Agent')}
                          </Typography>
                          <Box sx={{ 
                            background: isMe ? '#2563eb' : '#f1f5f9', 
                            color: isMe ? '#fff' : '#000', 
                            borderRadius: '12px', 
                            padding: { xs: '8px 12px', md: '10px 14px' }, 
                            fontSize: '14px',
                            wordBreak: 'break-word',
                            boxShadow: '0 1px 2px rgba(0,0,0,0.1)'
                          }}>
                            {msg.message_text}
                          </Box>
                          <Box sx={{ 
                            fontSize: '10px', 
                            color: '#888', 
                            marginTop: '4px', 
                            display: 'flex', 
                            alignItems: 'center', 
                            gap: '4px' 
                          }}>
                            {formatMessageTime(msg.timestamp)}
                            {getMessageStatusIcon(msg.status, isMe)}
                          </Box>
                        </Box>
                      </Box>
                    );
                  })}
                  <div ref={messagesEndRef} />
                </>
              ) : (
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                  <Typography sx={{ color: '#888', fontSize: '14px' }}>No messages yet. Start the conversation!</Typography>
                </Box>
              )}
            </Box>

            <Box sx={{ 
              display: 'flex', 
              alignItems: 'center', 
              padding: '12px 16px', 
              borderTop: '1px solid #eee', 
              background: '#fff',
              flexShrink: 0,
              gap: '12px'
            }}>
              <InputBase
                placeholder="Type your message..."
                value={inputMessage}
                onChange={handleInputChange}
                onKeyPress={(e) => {
                  if (e.key === 'Enter' && !e.shiftKey) {
                    e.preventDefault();
                    sendMessage();
                  }
                }}
                disabled={!socketConnected}
                sx={{
                  flex: 1,
                  padding: '10px 16px',
                  borderRadius: '20px',
                  border: '1px solid #ddd',
                  background: '#f8f9fa',
                  fontSize: '14px',
                  transition: 'all 0.2s',
                  '&:focus-within': {
                    background: '#fff',
                    borderColor: '#2563eb'
                  },
                  '&.Mui-disabled': {
                    opacity: 0.6,
                    cursor: 'not-allowed'
                  }
                }}
              />
              <IconButton
                onClick={sendMessage}
                disabled={!inputMessage.trim() || !socketConnected}
                sx={{
                  transition: 'transform 0.2s',
                  '&:hover': {
                    transform: 'scale(1.1)'
                  },
                  '&:disabled': {
                    opacity: 0.4
                  }
                }}
              >
                <Box component="img" src={sendIcon} sx={{ width: '28px', height: '28px' }} />
              </IconButton>
            </Box>
          </>
        ) : (
          <Box sx={{
            display: 'flex',
            justifyContent:            'center',
            alignItems: 'center',
            height: '100%',
            flexDirection: 'column',
            padding: '20px'
          }}>
            <Typography variant="h6" sx={{ color: '#555', marginBottom: '10px' }}>
              Select a conversation
            </Typography>
            <Typography variant="body2" sx={{ color: '#888', textAlign: 'center' }}>
              Choose a conversation from the list to start chatting
            </Typography>
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default ProfileInbox;

